import { ComponentProps, VariantProps } from '@stitches/react'
import { ReviewCardRoot } from './ReviewCard.styles'

type ReviewCardVariants = VariantProps<typeof ReviewCardRoot>
type ReviewCardOwnProps = ComponentProps<typeof ReviewCardRoot>

export type ReviewCardProps = ReviewCardOwnProps & ReviewCardVariants & {}

export const ReviewCard = ({ children, color }: ReviewCardProps) => {
  return (
    <ReviewCardRoot className="item" color={color}>
      {children}
    </ReviewCardRoot>
  )
}
